module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/templates/reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Report Templates")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.varHelpVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Variable Reference\n\t\t\t\t")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Report Name",
      "col-class": "col-md-2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.template_name),
      expression: "report.template_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.report.template_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.report.template_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Preface Page Text",
      "col-class": "col-md-2"
    }
  }, [_c('rich-text', {
    attrs: {
      "id": "preface_text"
    },
    model: {
      value: (_vm.report.preface_text),
      callback: function($$v) {
        _vm.report.preface_text = $$v
      },
      expression: "report.preface_text"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h2', [_vm._v("Included in Report Template")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('draggable', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "options": {
        group: 'sections'
      }
    },
    on: {
      "change": _vm.save
    },
    model: {
      value: (_vm.includedSections),
      callback: function($$v) {
        _vm.includedSections = $$v
      },
      expression: "includedSections"
    }
  }, _vm._l((_vm.includedSections), function(section) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(section.heading) + "\n\t\t\t\t\t\t\t"), (section.template_description != '') ? _c('div', [_c('small', [_vm._v("(" + _vm._s(section.template_description) + ")")])]) : _vm._e()])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h2', [_vm._v("Available Sections")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('draggable', {
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "options": {
        group: 'sections'
      }
    },
    model: {
      value: (_vm.availableSections),
      callback: function($$v) {
        _vm.availableSections = $$v
      },
      expression: "availableSections"
    }
  }, _vm._l((_vm.availableSections), function(section) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(section.heading) + "\n\t\t\t\t\t\t\t"), (section.template_description != '') ? _c('div', [_c('small', [_vm._v("(" + _vm._s(section.template_description) + ")")])]) : _vm._e()])
  }))], 1)])])], 1), _vm._v(" "), (_vm.varHelpVisible) ? _c('variable-help', {
    attrs: {
      "modal-visible": _vm.varHelpVisible
    },
    on: {
      "close": function($event) {
        _vm.varHelpVisible = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Drag over section templates from right to left to include them in this report template")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e44b5c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReportTemplateEditor.vue
// module id = 296
// module chunks = 0